"use client";

import { useState } from "react";
import { CalendarDays, Rocket, ChevronDown, Circle } from "lucide-react";



const dateRangeOptions = ["Last 7 days", "Last 30 days", "Large 90 days"];

const TenantAnalyticsFilters = ({
  selectedCampaign,
  selectedDateRange,
  onCampaignChange,
  onDateRangeChange,
  campaignOptions
}) => {
  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      <FilterSelect
        icon={Rocket}
        value={selectedCampaign}
        options={campaignOptions}
        onChange={onCampaignChange}
        className="sm:w-[330px]"
      />

      <FilterSelect
        icon={CalendarDays}
        value={selectedDateRange}
        options={dateRangeOptions}
        onChange={onDateRangeChange}
        className="sm:w-[150px]"
      />
    </div>
  );
};

const FilterSelect = ({
  icon: Icon,
  value,
  options,
  onChange,
  className = "",
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex h-9 w-full items-center justify-between rounded-md border border-[#00A9D6] bg-[#1B263A] px-3 text-left text-sm text-neutral-100 outline-none"
      >
        <span className="flex min-w-0 items-center gap-2">
          <Icon className="h-4 w-4 shrink-0 text-[#67D8FF]" />
          <span className="truncate">{value}</span>
        </span>

        <ChevronDown className="h-4 w-4 shrink-0 text-[#67D8FF]" />
      </button>

      {open && (
        <div className="absolute right-0 z-40 mt-1 w-full overflow-hidden rounded-md border border-[#00A9D6] bg-[#2A2355] shadow-lg">
          {options.map((option) => {
            const isSelected = option === value;

            return (
              <button
                key={option}
                type="button"
                onClick={() => {
                  onChange(option);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-neutral-100 hover:bg-[#3A3170] ${
                  isSelected ? "bg-[#584B8C]" : ""
                }`}
              >
                <span
                  className={`flex h-4 w-4 items-center justify-center rounded-full border ${
                    isSelected ? "border-[#00D3F2]" : "border-neutral-100/50"
                  }`}
                >
                  {isSelected && (
                    <span className="h-2 w-2 rounded-full bg-[#00D3F2]" />
                  )}
                </span>

                <span className="truncate">{option}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TenantAnalyticsFilters;
